import React from 'react';
import PropTypes from 'prop-types';
import { getComponentClasses } from '@99designs/common/utils/app';

export default function BlankState({ title, message, variations }) {
    return (
        <div className={getComponentClasses('blank-slate', variations)}>
            <h4 className="blank-slate__heading">{title}</h4>
            <p className="blank-slate__message">{message}</p>
        </div>
    );
}

BlankState.displayName = 'BlankSlate';

BlankState.defaultProps = {
    variations: [],
};

BlankState.propTypes = {
    title: PropTypes.node.isRequired,
    message: PropTypes.node.isRequired,
    variations: PropTypes.arrayOf(PropTypes.string),
};



// WEBPACK FOOTER //
// ./src/js/components/BlankSlate.jsx